import { isKik } from "../../utils/platform";
import { dotFlowCallbackFb } from "../../utils/facebookWebview";
import { dotFlowCallbackKik } from "../../utils/kikWebview";
import userMapper from "../mappers/user";

export default message => (dispatch, getState) => {
  const { _id, username } = userMapper(getState());
  if (isKik()) {
    return dotFlowCallbackKik(_id, username, message);
  } else {
    return dotFlowCallbackFb(_id, message);
  }
};



// WEBPACK FOOTER //
// ./src/store/epics/dotFlowCallback.js